import { createAsyncAction } from "typesafe-actions";
import FaqPagination from "../../models/faq/FaqPagination";
import { GetFaqRequest } from "../../models/faq/GetFaqRequest";
import { GetFaqActionTypes, GetFaqNotificationsActionTypes,GetFaqOnboardingMessageActionTypes } from "./types";

export const getFaqActions = createAsyncAction(
    GetFaqActionTypes.REQUEST,
    GetFaqActionTypes.SUCCESS,
    GetFaqActionTypes.ERROR
)<GetFaqRequest, FaqPagination, undefined>();

export const getFaqNotificationsActions = createAsyncAction(
    GetFaqNotificationsActionTypes.REQUEST,
    GetFaqNotificationsActionTypes.SUCCESS,
    GetFaqNotificationsActionTypes.ERROR
)<undefined, FaqPagination, undefined>();

export const getFaqOnboardingMessageActions = createAsyncAction(
    GetFaqOnboardingMessageActionTypes.REQUEST,
    GetFaqOnboardingMessageActionTypes.SUCCESS,
    GetFaqOnboardingMessageActionTypes.ERROR
)<undefined, FaqPagination, undefined>();